import {css} from '@emotion/core';
import {
  getValueAtBreakpoint,
} from '../../modules/constants/BreakPoints';
import colors from '../../modules/constants/colors';

const loadingIcon = (width, height) => {
  return css`
    display: block;
    margin: auto;
    width: ${width}rem;
    height: ${height}rem;
    padding-top: 5rem;
  `;
}

const loadingIconWithExplainer = css`
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const loadingExplainer = (size) => {
  const fontSize = getValueAtBreakpoint(size, {
    'xsmall': 13,
    'small': 13,
    'medium': 16,
    'large': 16,
  });

  return css`
    margin-top: 15px;
    color: ${colors.violet};
    font-size: ${fontSize}px;
    text-align: center;
  `;
};

export default {
  loadingExplainer,
  loadingIcon,
  loadingIconWithExplainer,
}
